import { getPlaceholderText } from '../utils/capabilitiesEditorKnownPlaceholders';
import { jsx as _jsx } from "react/jsx-runtime";
const CapabilitiesEditorPlaceholder = ({
  placeholder
}) => {
  if (!placeholder) {
    return null;
  }
  const knownI18nPlaceholder = getPlaceholderText(placeholder);
  return /*#__PURE__*/_jsx("span", {
    children: knownI18nPlaceholder || placeholder
  });
};
CapabilitiesEditorPlaceholder.displayName = 'CapabilitiesEditorPlaceholder';
export default CapabilitiesEditorPlaceholder;